import HttpClient from '../../services/HttpClient';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getBaseURL } from '../../services/getBaseURL';
import { getUserToken } from '../../services/utils';

const http = new HttpClient();
const baseURL = getBaseURL().wallet;

const initialState = {
	documentList: [],
	categoriesList: [],
	documents: [],
	documentItem: undefined,
	isLoading: {
		backdrop: false,
		form: false,
		skeleton: false,
		button: false,
	},
	stateOtpSend: {},
	mehrAccountInfo: {
		Mobile: '',
		EnName: '',
		EnFamily: '',
		BankHesabNumber: '',
	},
	bankVerify: {
		CBIStatus: '',
		Flag: '',
	},
	StatusCode: null,
	bankValidation: null,
	errorOtp: false,
	confirmState: null,
	statusAPI: '',
	bankVerifyStatus: {},
	bankverifyError: {
		isResponse: false,
		isError: false,
	},
	hasTamin: {},
	jobStatus: {},
	videoAuthentication: {},
	bluVerification: {},
	isRetryState: false,
	barcodeValidation: {},
	qmbGateway: {},
	isCheck: false,
};

// getWalletDocuments
export const getWalletDocuments = createAsyncThunk('/GetDocument', async (params, thunkAPI) => {
	const { walletRequestID, isToastfy, Position, endPoint } = params;
	const body = {
		WalletRequestID: walletRequestID,
		Position,
	};

	let token = getUserToken(thunkAPI);
	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};

	const response = await http
		.post(`${baseURL}/${endPoint || 'GetDocument'}`, body, extraConfig, isToastfy)
		.then((res) => res.data);
	return response;
});

// showItemOfDocument
export const showItemOfDocument = createAsyncThunk('/showItemOfDocument', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);

	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};

	const response = await http.post(`${baseURL}/GetDocument`, params, extraConfig).then((res) => res.data);
	return response;
});

// showItemOfDocument
export const getWalletStatusDocument = createAsyncThunk(
	'/getWalletStatusDocument',
	async (params, thunkAPI) => {
		const { walletRequestID, isToastfy, Position } = params;

		const body = {
			WalletRequestID: walletRequestID,
			//WalletRequestID: 1000407,
			Position,
		};

		let token = getUserToken(thunkAPI);
		const extraConfig = {
			headers: {
				'Authorization': token,
			},
		};

		const response = await http
			.post(`${baseURL}/GetDocument`, body, extraConfig, isToastfy)
			.then((res) => res.data);
		return response;
	},
);

////////////////////
export const getWalletComplete = createAsyncThunk('/status-view', async (params, thunkAPI) => {
	const { walletRequestID, isToastfy } = params;

	const body = {
		WalletRequestID: walletRequestID,
	};

	let token = getUserToken(thunkAPI);
	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};

	const response = await http
		.post(`${baseURL}/WalletComplete`, body, extraConfig, isToastfy)
		.then((res) => res.data);
	return response;
});
//////////////////////

export const getBluBankVerification = createAsyncThunk('/BluBankVerification', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);
	const extraConfig = {
		headers: {
			'Authorization': token,
			// 'Authorization': 'berear 33e0a44b-b27a-47b1-adb3-e92b8ad59738',
		},
	};

	const response = await http
		.post(`${baseURL}/BluBankVerification`, params, extraConfig)
		.then((res) => res.data);
	return response;
});

// setter
export const setWalletDocuments = createAsyncThunk('/SetDocument', async (requestBody, thunkAPI) => {
	let token = getUserToken(thunkAPI);
	const config = {
		...requestBody,
		...requestBody?.config,
		headers: {
			'Authorization': token,
		},
	};

	const response = await http
		.post(`${baseURL}/SetDocument`, requestBody?.data, config, requestBody?.isToastfy)
		.then((res) => res.data);
	return response;
});

// delete
export const deleteWalletDocument = createAsyncThunk(
	'/Wallet/DeleteDocument ',
	async (requestBody, thunkAPI) => {
		let token = getUserToken(thunkAPI);

		const extraConfig = {
			headers: {
				'Authorization': token,
				// 'Authorization': 'berear 33e0a44b-b27a-47b1-adb3-e92b8ad59738',
			},
		};

		const response = await http
			.post(`${baseURL}/DeleteDocument `, requestBody, extraConfig, requestBody?.isToastfy)
			.then((res) => res.data);
		return response;
	},
);

///sendOtp
export const getWalletSendOtp = createAsyncThunk('/', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);

	const extraConfig = {
		headers: {
			'Authorization': token,
			// 'Authorization': 'berear 33e0a44b-b27a-47b1-adb3-e92b8ad59738',
		},
	};

	const param = {
		WalletRequestID: params?.WalletRequestID,
	};

	const response = await http
		.post(`${baseURL}/WalletSendOtp`, param, extraConfig, params?.isToastfy)
		.then((res) => res.data);
	return response;
});

///ResendOtp
export const getWalletReSendOtp = createAsyncThunk('/otp', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);

	const extraConfig = {
		headers: {
			// 'Authorization': 'berear 33e0a44b-b27a-47b1-adb3-e92b8ad59738',
			'Authorization': token,
		},
	};

	const param = {
		WalletRequestID: params.WalletRequestID, // params.WalletRequestID,
	};

	const response = await http.post(`${baseURL}/WalletReSendOtp`, param, extraConfig).then((res) => res.data);
	return response;
});

///otp Confirm
export const WalletConfirmOtp = createAsyncThunk('/otpConfirm', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);

	const extraConfig = {
		headers: {
			// 'Authorization': 'berear 33e0a44b-b27a-47b1-adb3-e92b8ad59738',
			'Authorization': token,
		},
	};

	const param = {
		WalletRequestID: params.WalletRequestID, // params.WalletRequestID,
		Otp: params.Otp,
	};

	const response = await http.post(`${baseURL}/WalletConfirmOtp`, param, extraConfig).then((res) => res.data);
	return response;
});

// CBIVerification
export const CBIVerification = createAsyncThunk('wallet/CBIVerification', async (params, thunkAPI) => {
	const { walletRequestID, isToastfy } = params;

	let token = getUserToken(thunkAPI);

	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};
	const param = {
		walletRequestID: walletRequestID,
	};
	const response = await http
		.post(`${baseURL}/CBIVerification`, param, extraConfig, isToastfy)
		.then((res) => res.data);
	return response;
});

export const SaipaInquiryVerification = createAsyncThunk(
	'SaipaInquiryVerification',
	async (params, thunkAPI) => {
		const { walletRequestID, isToastfy } = params;

		let token = getUserToken(thunkAPI);

		const extraConfig = {
			headers: {
				'Authorization': token,
			},
		};
		const param = {
			walletRequestID: walletRequestID,
		};
		const response = await http
			.post(`${baseURL}/SaipaInquiryVerification`, param, extraConfig, isToastfy)
			.then((res) => res.data);
		return response;
	},
);

// checkCustomerStatus
export const checkCustomerStatus = createAsyncThunk('/checkCustomerStatus', async (params, thunkAPI) => {
	const { walletRequestID, isToastfy } = params;

	let token = getUserToken(thunkAPI);

	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};
	const param = {
		walletRequestID: walletRequestID,
	};
	const response = await http
		.post(`${baseURL}/CheckCustomerStatus`, param, extraConfig, isToastfy)
		.then((res) => res.data);
	return response;
});

//confirmCustomerStatus
export const confirmCustomerStatus = createAsyncThunk('/confirmCustomerStatus', async (params, thunkAPI) => {
	const { WalletRequestID, isToastfy } = params;

	let token = getUserToken(thunkAPI);

	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};
	const param = {
		walletRequestID: WalletRequestID,
	};
	const response = await http
		.post(`${baseURL}/CheckCustomerStatusConfirm`, param, extraConfig, isToastfy)
		.then((res) => res.data);
	return response;
});

// check
export const checkJobAuthStatus = createAsyncThunk('/LiveVideo', async (params, thunkAPI) => {
	const { walletRequestID, isToastfy } = params;

	const body = {
		WalletRequestID: walletRequestID,
	};

	let token = getUserToken(thunkAPI);
	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};

	const response = await http
		.post(`${baseURL}/LiveVideo`, body, extraConfig, isToastfy)
		.then((res) => res.data);
	return response;
});

// barcode the Tara wallet
export const taraVerifyAction = createAsyncThunk('/TaraVerify', async (params, thunkAPI) => {
	const { isToastfy, ...rest } = params;

	const body = {
		...rest,
	};

	let token = getUserToken(thunkAPI);
	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};

	const response = await http
		.post(`${baseURL}/TaraVerify`, body, extraConfig, isToastfy)
		.then((res) => res.data);
	return response;
});

// barcode the Tara wallet
export const confirmPaymentAction = createAsyncThunk('/TaraConfirm', async (params, thunkAPI) => {
	const { isToastfy, ...rest } = params;

	const body = {
		...rest,
	};

	let token = getUserToken(thunkAPI);
	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};

	const response = await http
		.post(`${baseURL}/TaraConfirm`, body, extraConfig, isToastfy)
		.then((res) => res.data);
	return response;
});

// iCSRequestAction
export const iCSRequestAction = createAsyncThunk('/iCSRequestAction', async (params, thunkAPI) => {
	const { isToastfy, ...rest } = params;

	const body = {
		...rest,
	};

	let token = getUserToken(thunkAPI);
	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};

	const response = await http
		.post(`${baseURL}/ICSRequest`, body, extraConfig, isToastfy)
		.then((res) => res.data);
	return response;
});

// iCSValidateOtp
export const iCSValidateOtpAction = createAsyncThunk('/iCSValidateOtp', async (params, thunkAPI) => {
	const { isToastfy, ...rest } = params;

	const body = {
		...rest,
	};

	let token = getUserToken(thunkAPI);

	const headerConfig = {
		headers: {
			'Authorization': token,
		},
	};

	const response = await http.post(`${baseURL}/iCSValidateOtp`, body, headerConfig, isToastfy);

	return response;
});

// iCSResendOTP
export const iCSResendOTPAction = createAsyncThunk('/iCSResendOTP', async (params, thunkAPI) => {
	const { isToastfy, ...rest } = params;

	const body = {
		...rest,
	};

	let token = getUserToken(thunkAPI);

	const headerConfig = {
		headers: {
			'Authorization': token,
		},
	};

	const response = await http.post(`${baseURL}/ICSResendOTP`, body, headerConfig, isToastfy);

	return response;
});

const walletRequestTwo = createSlice({
	name: 'walletRequestTwo',
	initialState,
	reducers: {
		setWalletCreditInfoNewFlow(state, action) {
			state.walletCreditInfo = action.payload;
		},

		clearDocumentItem(state) {
			state.documentList = [];
		},
		setCheck(state, action) {
			state.isCheck = action.payload;
		},

		clearDocumentList(state) {
			state.documentList = [];
			state.categoriesList = [];
			state.documentItem = {};
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(getWalletDocuments.pending, (state) => {
				state.isLoading.skeleton = true;
			})
			.addCase(getWalletDocuments.fulfilled, (state, action) => {
				const { Content, Success } = action.payload;

				if (Success) {
					state.categoriesList = Content?.Categories || [];
					state.documentList = Content?.Documents || [];
				}
				state.isLoading.skeleton = false;
			})
			.addCase(getWalletDocuments.rejected, (state) => {
				state.isLoading.skeleton = false;
			});
		builder
			.addCase(showItemOfDocument.pending, (state) => {
				state.isLoading.skeleton = true;
			})
			.addCase(showItemOfDocument.fulfilled, (state, action) => {
				const { Content } = action.payload;

				state.isLoading.skeleton = false;
				state.documentList = Content?.Documents || [];
				state.categoriesList = Content?.Categories || [];
			})
			.addCase(showItemOfDocument.rejected, (state) => {
				state.isLoading.skeleton = false;
			});
		builder
			.addCase(setWalletDocuments.pending, (state) => {
				state.isLoading.button = true;
				state.statusAPI = 'pending';
			})
			.addCase(setWalletDocuments.fulfilled, (state, action) => {
				const { Success, Content, Status } = action.payload;
				state.isLoading.button = false;
				state.statusAPI = Success ? 'success' : 'error';
				(state.StatusCode = Status), (state.documentItem = Content?.Documents);
			})
			.addCase(setWalletDocuments.rejected, (state) => {
				state.isLoading.button = false;
				state.statusAPI = 'error';
			});

		builder
			.addCase(getWalletStatusDocument.pending, (state) => {
				state.isLoading.skeleton = true;
			})
			.addCase(getWalletStatusDocument.fulfilled, (state, action) => {
				const { Content } = action.payload;
				state.isLoading.skeleton = false;
				const foundWalletOne = Content.Categories.find((item) => item.Key === 'Wallet.1');

				state.jobStatus = foundWalletOne?.Status;
			})
			.addCase(getWalletStatusDocument.rejected, (state) => {
				state.isLoading.skeleton = false;
			});
		builder
			.addCase(deleteWalletDocument.pending, (state) => {
				state.isLoading.button = true;
			})
			.addCase(deleteWalletDocument.fulfilled, (state, action) => {
				const { Success } = action.payload;
				state.isLoading.button = false;
				state.statusAPI = Success ? 'success' : 'error';
			})
			.addCase(deleteWalletDocument.rejected, (state) => {
				state.isLoading.button = false;
				state.statusAPI = 'error';
			});
		builder
			.addCase(getWalletSendOtp.pending, (state) => {
				state.isLoading.button = true;
			})
			.addCase(getWalletSendOtp.fulfilled, (state, action) => {
				const { Content } = action.payload;
				state.isLoading.button = false;
				state.stateOtpSend = Content;
			})
			.addCase(getWalletSendOtp.rejected, (state) => {
				state.isLoading.button = false;
			});

		builder
			.addCase(checkCustomerStatus.pending, (state) => {
				state.isLoading.skeleton = true;
			})
			.addCase(checkCustomerStatus.fulfilled, (state, action) => {
				const { Content } = action.payload;
				state.isLoading.skeleton = false;
				state.hasTamin = Content;
			})
			.addCase(checkCustomerStatus.rejected, (state) => {
				state.isLoading.skeleton = false;
			});
		builder
			.addCase(getBluBankVerification.pending, (state) => {
				state.isLoading.skeleton = true;
			})
			.addCase(getBluBankVerification.fulfilled, (state, action) => {
				const { Content, Status, Success } = action.payload;
				state.isLoading.skeleton = false;
				state.bluVerification = {
					Status,
					Success,
					Content: Content?.Status,
				};
			})
			.addCase(getBluBankVerification.rejected, (state) => {
				state.isLoading.skeleton = false;
			});
		builder
			.addCase(confirmCustomerStatus.pending, (state) => {
				state.isLoading.button = true;
			})
			.addCase(confirmCustomerStatus.fulfilled, (state) => {
				state.isLoading.button = false;
				// state.hasTamin = Content;
			})
			.addCase(confirmCustomerStatus.rejected, (state) => {
				state.isLoading.button = false;
			});
		builder
			.addCase(getWalletReSendOtp.pending, (state) => {
				state.isLoading.button = true;
			})
			.addCase(getWalletReSendOtp.fulfilled, (state, action) => {
				const { Content, Success } = action.payload;
				state.isLoading.button = false;
				if (Success) {
					state.stateOtpSend = Content;
				}
			})
			.addCase(getWalletReSendOtp.rejected, (state) => {
				state.isLoading.button = false;
			});

		builder
			.addCase(WalletConfirmOtp.pending, (state) => {
				state.isLoading.skeleton = true;
			})
			.addCase(WalletConfirmOtp.fulfilled, (state, action) => {
				const { Success, Content } = action.payload;
				if (Success) {
					state.confirmState = Content;
					state.errorOtp = false;
				} else {
					state.errorOtp = true;
				}
			})
			.addCase(WalletConfirmOtp.rejected, (state) => {
				state.isLoading.skeleton = false;
			});
		builder
			.addCase(CBIVerification.pending, (state) => {
				state.status = 'pending';
				state.isLoading.skeleton = true;
			})
			.addCase(CBIVerification.fulfilled, (state, action) => {
				const { Content, Message, Status } = action.payload;

				state.bankValidation = {
					Message,
					Status,
					Content,
				};
				if (Status === 200) {
					state.isLoading.skeleton = false;

					state.bankVerify.CBIStatus = Content?.CBIStatus;
					state.bankVerify.Flag = Content?.Flag;
					state.bankVerifyStatus = Content;
				}
				if (Status === 658) {
					state.isLoading.skeleton = true;
					state.bankverifyError.isResponse = true;
				}
				if (![658, 200].includes(Status)) {
					state.isLoading.skeleton = true;

					state.bankverifyError.isError = true;
				}
			})
			.addCase(CBIVerification.rejected, (state, action) => {
				const { Message, Status, Content } = action.payload;
				state.status = 'error';
				state.isLoading.skeleton = false;
				state.bankValidation = {
					Message,
					Status,
					Content,
				};
			});
		builder
			.addCase(SaipaInquiryVerification.pending, (state) => {
				state.status = 'pending';
				state.isLoading.skeleton = true;
			})
			.addCase(SaipaInquiryVerification.fulfilled, (state, action) => {
				const { Content, Message, Status } = action.payload;

				state.bankValidation = {
					Message,
					Status,
					Content,
				};
				if (Status === 200) {
					state.isLoading.skeleton = false;

					state.bankVerify.CBIStatus = Content?.CBIStatus;
					state.bankVerify.Flag = Content?.Flag;
					state.bankVerifyStatus = Content;
				}
				if (Status === 658) {
					state.isLoading.skeleton = true;
					state.bankverifyError.isResponse = true;
				}
				if (![658, 200].includes(Status)) {
					state.isLoading.skeleton = true;

					state.bankverifyError.isError = true;
				}
			})
			.addCase(SaipaInquiryVerification.rejected, (state, action) => {
				const { Message, Status, Content } = action.payload;
				state.status = 'error';
				state.isLoading.skeleton = false;
				state.bankValidation = {
					Message,
					Status,
					Content,
				};
			});
		builder
			.addCase(checkJobAuthStatus.pending, (state) => {
				state.isLoading.skeleton = true;
			})
			.addCase(checkJobAuthStatus.fulfilled, (state, action) => {
				state.isLoading.skeleton = false;
				state.videoAuthentication = action.payload;
			})
			.addCase(checkJobAuthStatus.rejected, (state, action) => {
				state.isLoading.skeleton = false;
				state.videoAuthentication = action.payload;
			});
		builder
			.addCase(taraVerifyAction.pending, (state) => {
				state.isLoading.skeleton = true;
			})
			.addCase(taraVerifyAction.fulfilled, (state, action) => {
				state.isLoading.skeleton = false;
				const { Message, Status, Content } = action.payload;
				state.barcodeValidation = {
					Content,
					Status,
					Message,
				};
			})
			.addCase(taraVerifyAction.rejected, (state) => {
				state.isLoading.skeleton = false;
			});
		builder
			.addCase(iCSRequestAction.pending, (state) => {
				state.isLoading.button = true;
			})
			.addCase(iCSRequestAction.fulfilled, (state) => {
				state.isLoading.button = false;
			})
			.addCase(iCSRequestAction.rejected, (state) => {
				state.isLoading.button = false;
			});

		builder
			.addCase(iCSValidateOtpAction.pending, (state) => {
				state.isLoading.form = true;
			})
			.addCase(iCSValidateOtpAction.fulfilled, (state) => {
				state.isLoading.form = false;
			})
			.addCase(iCSValidateOtpAction.rejected, (state) => {
				state.isLoading.form = false;
			});

		builder
			.addCase(iCSResendOTPAction.pending, (state) => {
				state.isLoading.form = true;
			})
			.addCase(iCSResendOTPAction.fulfilled, (state) => {
				state.isLoading.form = false;
			})
			.addCase(iCSResendOTPAction.rejected, (state) => {
				state.isLoading.form = false;
			});

		builder
			.addCase(confirmPaymentAction.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(confirmPaymentAction.fulfilled, (state) => {
				state.isLoading = false;
				// const { Message, Status, Content } = action.payload;
			})
			.addCase(confirmPaymentAction.rejected, (state) => {
				state.isLoading = false;
			});
		builder
			.addCase(getWalletComplete.pending, (state) => {
				state.isLoading.skeleton = true;
			})
			.addCase(getWalletComplete.fulfilled, (state) => {
				state.isLoading.skeleton = false;
			})
			.addCase(getWalletComplete.rejected, (state) => {
				state.isLoading.skeleton = false;
			});
	},
});
export const { clearDocumentList, clearDocumentItem, setCheck } = walletRequestTwo.actions;
export default walletRequestTwo.reducer;
